import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AvatarFromUserId_UserQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type AvatarFromUserId_UserQuery = { user?: { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null } | null };


export const AvatarFromUserId_UserDocument = gql`
    query AvatarFromUserId_user($id: uuid!) {
  user: users_by_pk(id: $id) {
    id
    user_avatar {
      public_url
    }
    full_name
  }
}
    `;

export function useAvatarFromUserId_UserQuery(options: Omit<Urql.UseQueryArgs<AvatarFromUserId_UserQueryVariables>, 'query'>) {
  return Urql.useQuery<AvatarFromUserId_UserQuery, AvatarFromUserId_UserQueryVariables>({ query: AvatarFromUserId_UserDocument, ...options });
};